<div class="track-block-item">
  <div class="track-block-item__cover">
    <bmcore-track-box-cover [track]="track" [tracks]="tracks"></bmcore-track-box-cover>
  </div>

  <div class="track-block-item__dots bm--cut">
    <a class="common-bmstv-title-1" routerLink="/beat/{{ track.id }}">{{ track.name }}</a>
  </div>
  <div class="track-block-item__dots bm--cut">
    <a class="common-bmstv-title-2" routerLink="/bm/{{ track.beatmakerId }}">
      {{ track.beatmakerName }}
    </a>
    @if (track.beatmakerVerified) {
      <bmcore-verify-icon></bmcore-verify-icon>
    }
  </div>

  <div class="track-block-item__info">
    <p class="track-block-item__info-price" (click)="wantToAddBeat($event, track.id)">
      {{ currencySign }} {{ track.minPrice }}
    </p>
    <hr class="common-divider" />
    <p class="track-block-item__info-bpm">{{ track.bpm }} bpm</p>
  </div>
</div>
